$(document).ready(function() {
    console.log('articles');
  
  
    if ($('.related-article-section').length) {
        $('.related-articles-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $('.related-articles-slider .float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause:true,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 20
                    },
                    1280: {
                        items: 3
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

  
    if ($('.related-products-section').length) {
        $('.related-products-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $('.related-products-slider .float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                loop: true,
                autoplay: true,
                autoplayHoverPause:true,
                autoplayTimeout: 5000,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 20
                    },
                    1280: {
                        items: 3
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }
  
  
});

$(window).on('scroll', function() {
  
});